import { appUrls } from '../config';
import getEvents from '../services/eventFetchService';
import { setNotification } from '../reducers/notification';
import { selectEvent } from '../reducers/events';

export default function deleteEvent(eventId, dispatch) {
  const data = new FormData();

  data.append('event_id', eventId);

  const params = {
    method: 'post',
    body: data,
    credentials: 'include'
  };

  fetch(appUrls.delete, params)
    .then((response) => {
      if (response.ok) {
        dispatch(setNotification('Tapahtuman poistaminen onnistui.'));
        dispatch(selectEvent(undefined));
        getEvents(dispatch);
      } else {
        dispatch(setNotification('Virhe: Tapahtuman poistaminen epäonnistui.'));
      }
    });
}



// WEBPACK FOOTER //
// ./src/services/deleteEvent.js